module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_6aedffd9.076fad6c.eot";